import React from 'react'

import { Print as PrintIcon } from '@material-ui/icons'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { Damaged } from 'src/api/models'
import { DamagedLabel } from 'src/components/PrintLabel/DamagedLabel'
import {
  DateTimeField,
  FieldSpec,
  LinkedField,
  LinkedPathField,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { DetailComponent, MenuItem } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  fields?: string[]
  menuItems?: string[]
  refresh?: () => void
}

const fieldOptions: { [key: string]: FieldSpec } = {
  guid: { id: 'guid', label: 'Damaged', renderer: LinkedField(ValueField) },
  client: {
    id: 'client',
    label: 'Client',
    ordering: 'account__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  facility: {
    id: 'facility',
    label: 'Name',
    ordering: 'facility__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  asn: {
    id: 'asn',
    label: 'ASN',
    ordering: 'asn__tracking_number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  batch: {
    id: 'batch',
    label: 'Batch',
    ordering: 'batch__client_uid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  path: { id: 'objPath', label: 'Path', ordering: 'place__search_path', renderer: LinkedPathField },
  product: {
    id: 'product',
    label: 'Product',
    ordering: 'product__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'sku'),
  },
  damage: { id: 'damage', label: 'Damage', renderer: ValueField },
  damagedBy: { id: 'damagedBy', label: 'Damaged By', ordering: 'by_us', renderer: ValueField },
  notes: { id: 'notes', label: 'Notes', renderer: ValueField },
  damagedOn: {
    id: 'damagedOn',
    label: 'Damaged On',
    ordering: 'created_on',
    renderer: DateTimeField,
  },
}

export const DamagedDetailTable = (props: DetailTableProps) => {
  const {
    obj,
    fields = [
      'guid',
      'client',
      'facility',
      'asn',
      'path',
      'product',
      'sku',
      'batch',
      'damage',
      'damagedBy',
      'notes',
      'damagedOn',
    ],
    menuItems = [],
  } = props
  const { print, renderPrintComponent } = useAsyncPrint()

  const menuOptions: { [key: string]: MenuItem } = {
    print: {
      Icon: PrintIcon,
      actions: [
        {
          title: 'Print Damaged Label',
          onClick: () => print((props) => <DamagedLabel {...props} obj={obj.data} />),
        },
      ],
    },
  }

  const finalFields = fields.map((field) => fieldOptions[field])

  return (
    <>
      {renderPrintComponent()}
      <DetailComponent
        obj={obj}
        Icon={Damaged.icon}
        menuItems={menuItems.map((item) => menuOptions[item])}
        fields={finalFields}
      />
    </>
  )
}
